/* src/components/common/ConfirmDialog.jsx - Última Modificación: 03-01-2026 */
/* ------------------------------------------------------------------------- */

import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Box,
  Divider,
} from '@mui/material';

/* ========================= */
/* 🎯 BOTONES DE ACCIÓN     */
/* ========================= */
const confirmButtonSx = {
  primary: (theme) => ({
    backgroundColor: theme.custom.ui.primaryActionBg,
    color: theme.custom.ui.primaryActionText,
    fontWeight: 600,
    borderRadius: 8,
    padding: '6px 16px',
    minHeight: 36,

    boxShadow: theme.custom.ui.primaryActionShadow,

    '&:hover': {
      backgroundColor: theme.custom.ui.primaryActionBgHover,
      boxShadow: theme.custom.ui.primaryActionShadowHover,
    },
  }),

  secondary: (theme) => ({
    backgroundColor: theme.custom.ui.secondaryActionBg,
    color: theme.custom.ui.secondaryActionText,
    fontWeight: 500,
    borderRadius: 8,
    padding: '6px 14px',
    minHeight: 36,

    border: `1px solid ${theme.custom.ui.secondaryActionBorder}`,

    '&:hover': {
      backgroundColor: theme.custom.ui.secondaryActionBgHover,
      boxShadow:
        theme.palette.mode === 'dark'
          ? `inset 0 0 0 1px ${theme.custom.ui.secondaryActionBorderHover}`
          : theme.custom.ui.surfaceShadow,
    },
  }),
};

/* ========================= */
/* 🧩 COMPONENTE            */
/* ========================= */
export default function ConfirmDialog({
  open,
  title = 'Confirmar acción',
  description,
  confirmText = 'Confirmar',
  cancelText = 'Cancelar',
  onConfirm,
  onCancel,
}) {
  return (
    <Dialog
      open={open}
      onClose={(event, reason) => {
        if (reason === 'backdropClick' || reason === 'escapeKeyDown') {
          return; // evita cierre accidental
        }
        onCancel();
      }}
      slotProps={{
        paper: {
          sx: (theme) => ({
            borderRadius: 8,
            border: `1px solid ${theme.custom.ui.borderSubtle}`,
            boxShadow: theme.custom.ui.modalShadow,
          }),
        },
      }}
    >
      {/* ---------- Header ---------- */}
      <DialogTitle
        sx={{
          fontWeight: 600,
          pb: 1,
        }}
      >
        {title}
      </DialogTitle>

      <Divider />

      {/* ---------- Content ---------- */}
      <DialogContent sx={{ pt: 2 }}>
        <Typography variant="body2" color="text.secondary">
          {description}
        </Typography>
      </DialogContent>

      {/* ---------- Actions ---------- */}
      <DialogActions
        sx={{
          px: 3,
          pt: 2,
          pb: 1.5,
          display: 'flex',
          justifyContent: 'flex-end',
          gap: 1.5,
        }}
      >
        <Button onClick={onCancel} sx={confirmButtonSx.secondary}>
          {cancelText}
        </Button>

        <Button
          variant="contained"
          onClick={onConfirm}
          autoFocus
          sx={confirmButtonSx.primary}
        >
          {confirmText}
        </Button>
      </DialogActions>

      <Divider />

      {/* ---------- Footer ---------- */}
      <Box
        sx={{
          px: 3,
          py: 1,
          display: 'flex',
          justifyContent: 'flex-end',
        }}
      >
        <Typography variant="caption" color="text.secondary">
          ▶️ Overwatch
        </Typography>
      </Box>
    </Dialog>
  );
}
